import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ComparePageHero } from "../components/ComparePageHero";
import { ComparePageLegacyBody } from "../components/ComparePageLegacyBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.ComparePageVariantPurpleTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <ComparePageHero page={props.page} />
            <ComparePageLegacyBody page={props.page} layout="legacy_purple" />
        </PageSkeleton>
    );
};
